import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWarp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWarp"><Path d="M10.2756 6.54823L7.34931 18.7478H11.9795L11.6793 19.9993H4.19415C2.98239 19.9993 2 18.9752 2 17.7123V8.83524C2 7.57234 2.98239 6.54823 4.19415 6.54823H10.2756Z" fill="currentColor"/><Path d="M19.7864 3.99991C21.0085 3.99991 22 5.02402 22 6.28692V15.1639C22 16.4269 21.0085 17.4509 19.7864 17.4509H8.98305L12.2365 3.99991H19.7864Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWarp;
